import React, {useEffect, useState} from 'react';
import {ThemedButton, ThemedDialog, ThemedDrawer, ThemedInput} from "../index";
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    extractHtmlInnerText,
    getDefStr,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    limitStringWords
} from "../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, formatDateValue, getUserSessionField, printError, printLog, sendRequest} from "../utils/AppUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {ModuleFieldsData, Modules, ReqUrls,} from "../config/AppConfig";
import {AutoCompleteView, Flexbox, HorDiv, Label, MsgBox} from "../../common/fusion-ui";
import {CssVariant, DefStrNA, Messages} from "../../common/fusion-ui/config/FusionConfig";
import {Tooltip} from "@mui/material";
import {useInternetStatus} from "../../common/fusion-ui/hook";

const MessageSenderDialog = React.memo(({
                                            recordId,
                                            asPanel = false,
                                            asDrawer = false,
                                            replyMode = false,
                                            replyData = {},
                                            disableSubmit = false,
                                            loadingSubmit = false,
                                            recipientNameAsEmail = true,
                                            clearData = false,
                                            selectedRecipients = [],
                                            open,
                                            onHide,
                                            onCancel,
                                            onSubmit,
                                        }) => {
    const TAG = "MessageSenderDialog";

    const mf = ModuleFieldsData[Modules.Messages];

    const NAME_KEY = 'name';

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const MSG_BODY_CHAR_LIMIT = 1500;

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',
        canShowFullMsgBody: 'canShowFullMsgBody',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [recList, setRecList] = useState([]);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        // log('useEffect.replyData:', replyData);
        // if (isBoolTrue(open)) {
        // if (!isFieldTrue(Fields.isDataFetched)) {
        //     updateField(Fields.isDataFetched, true);
        if (isReplyMode()) {
            if (!isFieldTrue(Fields.isDataFetched)) {
                updateField(Fields.isDataFetched, true);
                setFormData({});
                log('useEffect.replyMode.replyData:', replyData);
                const subject = getJsonValue(replyData, mf.subject.column) + '';
                const email = getDefStr(getJsonValue(replyData, mf.fromEmail.column), getJsonValue(replyData, mf.fromEmailAlt.column));
                const formData = {
                    [mf.fromName.column]: getJsonValue(replyData, mf.fromName.column),
                    [mf.fromEmail.column]: email,
                    [mf.msgBox_Subject.column]: `Re: ${subject}`,
                    // [mf.msgBox_Message.column]: getJsonValue(replyData, mf.body.column),
                    [mf.recipientsSelectedOnly.column]: [{
                        id: getJsonValue(replyData, mf.fromId.column),
                        name: getJsonValue(replyData, mf.fromName.column),
                        email: email
                    }],
                    [mf.thread.column]: getJsonValue(replyData, mf.thread.column),
                };
                setFormData(formData);
            }
        } else {
            if (!isFieldTrue(Fields.isDataFetched) && isBoolTrue(open)) {
                // setFieldsData({});
                // setFormData({});
                updateField(Fields.submitBtn_disabled, false);
                updateField(Fields.submitBtn_AsLoading, false);
                // log('useEffect.replyMode-false, dataFetched:', isFieldTrue(Fields.isDataFetched));
                log('useEffect.selectedRecipients:', selectedRecipients);
                fetchRecipientsData(!checkNullArr(selectedRecipients), selectedRecipients);
            }
        }
        // } else {
        // log('useEffect.open:', open);
        // if (onHide) onHide();
        // clearPanelData();
        // }
        // }
    }, [replyMode, replyData, selectedRecipients]);
    useEffect(() => {
        if (isReplyMode()) {
            // log('useEffect.replyMode.disableSubmit:', disableSubmit, 'loadingSubmit:', loadingSubmit, 'replyMode:', replyMode);
            // updateField(Fields.submitBtn_disabled, isBoolTrue(disableSubmit));
            // updateField(Fields.submitBtn_AsLoading, isBoolTrue(loadingSubmit));
        }
    }, [replyMode, disableSubmit, loadingSubmit]);
    useEffect(() => {
        // log('useEffect.clearData:', clearData);
        if (isBoolTrue(clearData)) {
            clearPanelData();
        }
    }, [clearData]);
    useEffect(() => {

    }, [selectedRecipients]);

    return (<>
        {isBoolTrue(asPanel) ? createPanel() : (isBoolTrue(asDrawer) ? createDrawer() : createDialog())}
    </>)

    //======================UI Functions start=====================
    function createDialog() {
        return <ThemedDialog
            className={"p-0"}
            open={isBoolTrue(open)}
            title={isReplyMode() ? 'Reply Message' : 'Send Message'}
            titleAt={'start'}
            padded={false}
            widthClass={`col-sm-10 col-md-8`}
            headerClassName={'py-2 px-4'}
            contentClassName={'px-3py-2'}
            maxHeight={'90vh'}
            showClose={true}
            showFooter={false}
            closeOnEscape={true}
            // closeOnEscape={!isFieldTrue(Fields.submitBtn_disabled)&&!isFieldTrue(Fields.submitBtn_AsLoading)}
            closeOnOutsideClick={false}
            onClose={() => {
                if (onCancel) onCancel();
                clearPanelData();
            }}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData();
            }}
            onEscapeClose={() => {
                if (onCancel) onCancel();
                clearPanelData();
            }}
            // onOutsideClick={onCancel}
        >
            <div className={'px-2'}>
                {createPanel()}
            </div>
        </ThemedDialog>
    }

    function createDrawer() {
        return <ThemedDrawer
            title={isReplyMode() ? 'Reply Message' : 'Send Message'}
            closeOnEscape={true}
            closeOnClickAway={false}
            open={isBoolTrue(open)}
            onClose={() => {
                if (onHide) onHide();
                clearPanelData();
            }}>
            {createPanel()}
        </ThemedDrawer>
    }

    function createPanel() {
        return <div className={'position-relative bg-infox w-100'}>
            {/*recipients*/}
            {!isReplyMode() && <div className={'bg-infox px-3 pt-2'}>
                <AutoCompleteView
                    wrapperClassName={''}

                    msgLabelColor={theme.text70}
                    nameColor={theme.text}
                    searchColor={theme.text}
                    dropdownItemHoverBg={theme.primaryBlue20}
                    dropdownItemHoverColor={theme.primaryBlueDark}
                    dropdownItemSelectedBg={theme.primaryBlue20}
                    dropdownItemSelectedColor={theme.primaryBlue}
                    tagBoxBorderColor={theme.text20}
                    labelColor={theme.text40}
                    countColor={theme.text40}
                    tagBg={theme.text10}
                    dropdownHeight={'50vh'}
                    tagBoxHeight={'35vh'}
                    searchPlaceholder={'Search for recipients...'}
                    label={"Recipients"}
                    required={true}
                    showLoading={false}
                    showCount={true}
                    showRefresh={true}

                    options={recList}
                    itemNameKey={isBoolTrue(recipientNameAsEmail) ? 'email' : NAME_KEY}
                    itemImageKey={'image'}
                    itemHoverAltNameKey={!isBoolTrue(recipientNameAsEmail) ? 'email' : NAME_KEY}
                    // itemNameKey={mf_up.fullName.column}
                    // itemEmailKey={mf_up.memberEmail1.column}
                    // itemMobileKey={mf_up.memberMobile1.column}
                    // itemUsernameKey={mf_up.memberEmail1.column}

                    imageSize={'22px'}
                    showNameInitials={true}
                    showAltNameOnHover={true}
                    synced={true}
                    removableTag={true}
                    removeColor={theme.text}
                    removeSize={'20px'}
                    refreshLoading={isFieldTrue(Fields.isDataLoading)}
                    disableRefresh={isFieldTrue(Fields.isDataLoading)}

                    onSelected={(updatedList, selectedList) => {
                        updateFormField(mf.recipientsSelectedOnly, selectedList);
                        log('recList.userList.onUsersSelected.updatedList:', updatedList);
                        log('AutoCompleteView.userList.onUsersSelected.selectedList:', selectedList);
                    }}
                    onRefresh={() => fetchRecipientsData(false)}
                    dropdownStyle={theme.autoCompleteDropdownStyles}
                />


            </div>}

            {/*msg-body*/}
            <div className={'mt-3 px-3 pb-2'}>
                {/*fromName*/}
                {isReplyMode() && <ThemedInput
                    wrapperClassName={''}
                    className={'select-text'}
                    label={mf.toName.title}
                    placeholder={mf.toName.title}
                    value={`${getFormField(mf.fromName)} (${getFormField(mf.fromEmail)})`}
                    readOnly={true}
                />}
                {/*msgBox_Subject*/}
                {<ThemedInput
                    wrapperClassName={''}
                    className={'select-text'}
                    label={mf.msgBox_Subject.title}
                    placeholder={mf.msgBox_Subject.title}
                    id={mf.msgBox_Subject.column}
                    type={'text'}
                    value={getFormField(mf.msgBox_Subject)}
                    msg={getFormFieldMsg(mf.msgBox_Subject)}
                    required={!isReplyMode()}
                    readOnly={isReplyMode()}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(mf.msgBox_Subject, value);
                        if (checkNullStr(value)) updateFormFieldMsg(mf.msgBox_Subject, '');
                    }}/>}

                {/*msgBox_Message*/}
                <div className={'w-100'}>
                    <ThemedInput
                        wrapperClassName={''}
                        className={'select-text'}
                        label={mf.msgBox_Message.title}
                        id={mf.msgBox_Message.column}
                        value={getFormField(mf.msgBox_Message)}
                        placeholder={mf.msgBox_Message.title}
                        msg={getFormFieldMsg(mf.msgBox_Message)}
                        required={true}
                        asTextArea={true}
                        style={{
                            minHeight: '230px',
                            height: '230px',
                            maxHeight: '500px'
                        }}
                        onChange={(e) => {
                            const value = e.target.value;
                            // log('Body-Input.onChange.value:', value);
                            updateFormField(mf.msgBox_Message, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.msgBox_Message, '');
                        }}/>

                    {/*<AppTextEditor*/}
                    {/*    label={mf.msgBox_Message.title}*/}
                    {/*    id={mf.msgBox_Message.column}*/}
                    {/*    value={getFormField(mf.msgBox_Message)}*/}
                    {/*    height={270}*/}
                    {/*    onChange={(value) => {*/}
                    {/*        // log('TextEditor.onChange.value:', value);*/}
                    {/*        updateFormField(mf.msgBox_Message, value);*/}
                    {/*        if (checkNullStr(value)) updateFormFieldMsg(mf.msgBox_Message, '');*/}

                    {/*    }}/>*/}
                </div>
            </div>

            {/*thread*/}
            {createThreadRecords()}

            {/*footer*/}
            <div className={'mt-2x mb-2 position-sticky py-2'}
                 style={{left: '0', bottom: isBoolTrue(asDrawer) ? '-1rem' : 0, backgroundColor: theme.bg, zIndex: 1}}>
                {/*msg-box*/}
                {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                    {getField(Fields.panelMsg)}
                </MsgBox>}

                {/*controls*/}
                <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                    {/*cancel*/}
                    <ThemedButton
                        className={'rounded-2 w-auto px-3 py-1'}
                        text={'Cancel'}
                        variant={theme.text}
                        bgColor={theme.text20}
                        hoverBgColor={theme.text30}
                        color={theme.text}
                        hoverColor={theme.text}
                        mx={2}
                        disabled={isFieldTrue(Fields.submitBtn_AsLoading)}
                        onClick={() => {
                            if (onCancel) onCancel();
                            clearPanelData();
                        }}
                    />

                    {/*send*/}
                    <ThemedButton
                        className={'rounded-2 w-auto px-3 py-1'}
                        icon={isReplyMode() ? 'bi bi-reply' : 'bi bi-send'}
                        text={isFieldTrue(Fields.submitBtn_AsLoading)
                            ? isReplyMode() ? 'Replying...' : 'Sending Email...'
                            : isReplyMode() ? 'Reply' : 'Send Email'}
                        variant={theme.primaryBlue}
                        hoverBgColor={theme.primaryBlueDark}
                        mx={2}
                        loadingWidth={'auto'}
                        asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                        disabled={isFieldTrue(Fields.submitBtn_disabled)}
                        onClick={handleSubmit}
                    />
                </Flexbox>
            </div>
        </div>
    }

    function createThreadRecords() {
        return (isReplyMode() && checkNullArr(getFormField(mf.thread))) &&
            <div className={'mt-3'}>
                <div className={''}>
                    <HorDiv variant={theme.text70}/>
                    <Label className={'m-0 p-0 fw-semi-bold'} color={theme.text50} textAt={'start'}>
                        Previous emails
                    </Label>
                </div>

                {getFormField(mf.thread).map((item, index) => {
                    return <div key={index + 'fgre'}
                                className={''} style={{color: theme.text}}>
                        {index > 0 && <HorDiv variant={theme.text60} width={2}/>}

                        {/*<div className={'text-wrap'}>*/}
                        {/*    Thread message-{index + 1}: {jsonToStr(item)}*/}
                        {/*</div>*/}

                        <div className={'px-3'}>
                            {/*fromName*/}
                            <div>
                                <Label className={'m-0 p-0'}>
                                    <span className={'fw-bold'}>{mf.fromName.title}: </span>
                                    {/*<span>{getJsonValue(item, mf.fromName.column, DefStrNA)} </span>*/}
                                    <span>{getJsonValue(item, isThreadRecordReceivedType(item) ? mf.toName.column : mf.fromName.column, DefStrNA)} </span>
                                </Label>
                            </div>

                            {/*send-date*/}
                            <div>
                                <Label className={'m-0 p-0'}>
                                    <span className={'fw-bold'}>Sent: </span>
                                    <span className={'text-nowrap'}>{formatDateValue(getJsonValue(item, mf.insertDate.column), DefStrNA)} </span>
                                </Label>
                            </div>

                            {/*toName*/}
                            <div>
                                <Label className={'m-0 p-0'}>
                                    <span className={'fw-bold'}>{mf.toName.title}: </span>
                                    {/*<span>{getJsonValue(item, mf.toName.column, DefStrNA)} </span>*/}
                                    <span>{getJsonValue(item, !isThreadRecordReceivedType(item) ? mf.toName.column : mf.fromName.column, DefStrNA)} </span>
                                </Label>
                            </div>

                            {/*subject*/}
                            <div>
                                <Label className={'m-0 p-0'}>
                                    <span className={'fw-bold'}>{mf.subject.title}: </span>
                                    <span>{getJsonValue(item, mf.subject.column, DefStrNA)} </span>
                                </Label>
                            </div>

                            {/*body*/}
                            <div className={'mt-2'}>
                                <div>
                                    <div className={'m-0 p-0 text-block fs-sm w-100 text-wrap'}
                                         dangerouslySetInnerHTML={{
                                             __html: isFieldTrue(Fields.canShowFullMsgBody)
                                                 ? getThreadRecordBody(item)
                                                 : limitStringWords(getThreadRecordBody(item), MSG_BODY_CHAR_LIMIT, '')
                                         }}
                                    />
                                    {((extractHtmlInnerText(getThreadRecordBody(item)) + '').length > MSG_BODY_CHAR_LIMIT) &&
                                        <div className={'d-flex jc-start bg-infox w-auto mb-1 mt-n2'}>
                                            <Tooltip title={isFieldTrue(Fields.canShowFullMsgBody) ? 'Collapse' : 'Expand'}>
                                                    <span
                                                        className={`cursor-pointer fs-normal fw-semi-bold bg-dangerx w-auto select-none rounded-2 px-1 highlight-primary-hover transition-sm d-flex al-center jc-center`}
                                                        style={{color: theme.text, height: '15px'}}
                                                        onClick={() => {
                                                            updateField(Fields.canShowFullMsgBody, !isFieldTrue(Fields.canShowFullMsgBody));
                                                        }}>
                                                        ...
                                                    </span>
                                            </Tooltip>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                })}
            </div>
    }

    function getThreadRecordBody(item) {
        return getJsonValue(item, mf.body.column, DefStrNA);
    }

    function isThreadRecordReceivedType(record = {}) {
        //	If msg.message_from == session.memberId, it's "sent"
        return !(getJsonValue(record, mf.fromId.column) == getUserSessionField('memberId'));
    }

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        const dataToSend = getFormDataToSend();
        //   log(fun, 'formData:', formData);
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }
        // log(fun, 'dataToSend:', dataToSend);
        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                if (onSubmit) onSubmit(dataToSend, recordId);
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchRecipientsData(checkBefore = true) {
        const fun = 'fetchRecipientsData:';
        try {
            if (!isBoolTrue(checkBefore) || (isBoolTrue(checkBefore) && !isFieldTrue(Fields.isDataFetched))) {
                updateField(Fields.isDataFetched, true);
                updateField(Fields.dataLoadingMsg, true);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.isDataFound, false);
                updateFormField(mf.recipientsSelectedOnly, []);
                setRecList([]);

                const REQUEST_OPTIONS = {
                    fetchImages: true
                };
                sendRequest({
                    reqUrl: ReqUrls.eventForm__fetch_participantsList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        let members = getJsonValueFromNestedKeys(fetchedData, ['data', 'members'], []);

                        setFormData(prevState => ({
                            ...prevState,
                            [mf.recipientsSelectedOnly.column]: checkNullArr(selectedRecipients) ? selectedRecipients : []
                        }));

                        if (checkNullArr(selectedRecipients)) {
                            log(fun, 'selectedRecipients:', selectedRecipients);

                            const updateList = [];
                            members.map((memItem) => {
                                selectedRecipients.map((recItem) => {
                                    updateList.push({
                                        ...memItem,
                                        selected: getJsonValue(memItem, 'id') == getJsonValue(recItem, 'id')
                                    });
                                });
                            });
                            log(fun, 'updateList:', updateList);
                            setRecList(updateList);
                        } else {
                            setRecList(members);
                        }

                        updateField(Fields.isDataLoading, false);
                        updateField(Fields.isDataFound, true);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.isDataLoading, false);
                        updateField(Fields.isDataFound, true);
                        updateField(Fields.dataLoadingMsg, "Couldn't load recipients!");
                    }),
                });
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
            updateField(Fields.dataLoadingMsg, "Couldn't load recipients!");
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            mf.msgBox_Subject,
            mf.msgBox_Message,
        ];
        if (!isReplyMode()) {
            requiredFields.unshift(mf.recipientsSelectedOnly);
        }

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (field.column === mf.recipientsSelectedOnly.column) {
                if (checkNullArr(getJsonValue(formData, field.column))) {
                    verified = true;
                } else {
                    colField = field;
                    verified = false;
                    break;
                }
            } else if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function getFormDataToSend() {
        return {
            subject: getFormField(mf.msgBox_Subject),
            body: extractHtmlInnerText(getFormField(mf.msgBox_Message)),
            recipients: checkNullArr(getFormField(mf.recipientsSelectedOnly, [])) ? getFormField(mf.recipientsSelectedOnly, []).map(item => ({
                id: getJsonValue(item, 'id'),
                [NAME_KEY]: getJsonValue(item, NAME_KEY),
                email: getJsonValue(item, 'email'),
            })) : [],
        };
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function clearPanelData() {
        setFormData({});
        setFormFieldsMsgs({});
        setFieldsData({});
        setRecList([]);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isReplyMode() {
        return isBoolTrue(replyMode);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default MessageSenderDialog;
